import dayjs from "dayjs";
import storageService from "../Services/storageService";
import { fireGtmEvent } from "./googleAnalytics";
import axios from "axios";
import toastr from "toastr";

var IMAGE_QUALITY = 100;

if (window?.navigator?.connection?.effectiveType === "3g") {
  IMAGE_QUALITY = 60;
} else if (window?.navigator?.connection?.effectiveType === "2g") {
  IMAGE_QUALITY = 40;
} else if (window?.navigator?.connection?.effectiveType === "slow-2g") {
  IMAGE_QUALITY = 20;
}

const instaProps = {
  493: "STRUNO6JPV6",
  1613: "STROFRCDXYU",
  372: "STRV4E23013",
  433: "STRUR3FEESB",
  1618: "STRNG84A7BP",
  5152: "STRKFCPLGB5",
  // 5152: "STRKFCPLGB5",
};

const deviceType =
  window.innerWidth < 768
    ? "Mobile"
    : window.innerWidth < 1024
    ? "Tablet"
    : "Desktop";

const instaPropsArr = [493, 1613, 372, 433, 1618, 5152];

// const excludedProperties = [
//   1931, 1755, 451, 1743, 1441, 1723, 692, 1640, 1413, 403, 2297, 1853, 1404,
//   2294, 429, 1780, 2307, 354, 1579, 1600, 1935, 1991, 2127, 1930, 1483, 1637,
//   2024, 1551, 2104, 1283, 2089, 1703, 1272, 2116, 1859, 2017, 1974, 1706, 1822,
//   1799, 1807, 428, 2008, 2122, 1800, 1699, 2121, 1989, 1944, 1590, 2241, 1520,
//   591, 1428, 1635, 1757, 1884, 1993, 1416, 1748, 1717, 1410, 1975, 498, 1445,
//   1667, 1858, 1480, 503, 2015, 1375, 2166, 2191, 1806, 1726, 1734, 1542, 2208,
//   1883, 1805, 2249, 2026, 1421, 2277, 1685, 1255, 1484, 2209, 1577, 1376, 1771,
//   1776, 1322, 1424, 1783, 1810, 1803, 1990, 1690, 1655, 1746, 1653, 1733, 1656,
//   1714, 1910, 691, 1292, 1433, 1821, 1727, 1366, 1847, 1268, 2366, 1905, 1676,
//   572, 1406, 1929, 2377, 2355, 1902, 1899, 1871, 1789, 1563, 971, 1397, 1837,
//   1755, 451, 1743, 1441, 1723, 692, 1640, 1413, 403, 2297, 1853, 1404, 2294,
//   429, 1780, 2307, 354, 1579, 1600, 1935, 1991, 2127, 1930, 1483, 1637, 2024,
//   1551, 2104, 1283, 2089, 1703, 1272, 2116, 1859, 2017, 1974, 1706, 1822, 1799,
//   1807, 2008, 428, 2122, 1800, 1699, 2121, 1989, 1944, 1590, 2241, 1520, 591,
//   1428, 1635, 1757, 1884, 1993, 1416, 1748, 1717, 1410, 1975, 498, 1445, 1667,
//   1858, 1480, 503, 2015, 1375, 2166, 2191, 1806, 1726, 1734, 1542, 2208, 1883,
//   1805, 2249, 2026, 1421, 2277, 1685, 1255, 1484, 2209, 1577, 1376, 1771, 1776,
//   1322, 1424, 1783, 1810, 1803, 1990, 1690, 1655, 1746, 1653, 1733, 1656, 1714,
//   1910, 691, 1292, 1433, 1821, 1727, 1366, 1847, 1268, 2366, 1905, 1676, 572,
//   1406, 1929, 2377, 2355, 1902, 1899, 1871, 1789, 1563, 529,
// ];

const tawkProps = [];

export const bot9Ids = [5157, 5151, 4607];

export const bot9Keys = {
  5157: "90715633-e048-41f9-8bc5-ee4ac465a997",
  // 529: "90715633-e048-41f9-8bc5-ee4ac465a997",
  5151: "04b890ff-5376-4c52-a94f-235c97dd0175",
  4607: "f0b1c1bc-d89c-4e78-ad45-0a1de7f7c05c",
  7875: "f30a57cf-7d64-4d76-bb80-1c154df4723a",
  7877: "21baee22-18df-4a35-8cf7-beeec6b75b56",

  // 5158: "9c64f43a-c161-4d5c-8aa1-c3eac5968a1b",
};

export const getFixedValue = (currency) =>
  ["INR", "IDR"].includes(currency) ? 0 : 2;

export const inhotelIds = {
  2269: "b1237b9c-3496-44d2-85ac-e6b4ea876385",
  // 372: "c00d76e7-7af6-443c-9065-da294b1a49bc",
  2740: "6348df3d-bc87-4bb7-8ec1-961a426113cf",
  1613: "98dba7b1-ca12-4669-a9b7-fe3c34950d87",
  1480: "3305acf5-763c-49d5-ad20-1137f21f231f",
  349: "44535994-7a58-450f-9839-385902bff713",
  493: "7da1a772-3102-46e5-b224-825c9a23317f",
  2297: "41a6df9a-c07f-4aa6-ab8c-5bb1855dc4b3",
  2776: "4dda4361-aad5-4d3f-bdfe-18db71fcea87",
  1720: "383b1ad3-968f-4846-9a43-75fb04f2ec27",
};

export const formatNumber = (num2) => {
  let num = Number(num2);
  if (num >= 100000) {
    let formattedNum = (num / 100000).toFixed(1);
    return (
      (formattedNum % 1 === 0 ? parseInt(formattedNum) : formattedNum) + "L"
    );
  } else if (num >= 1000) {
    let formattedNum = (num / 1000).toFixed(1);
    return (
      (formattedNum % 1 === 0 ? parseInt(formattedNum) : formattedNum) + "k"
    );
  } else {
    return num.toString();
  }
};

const scrollProperties = [
  1974, 1236, 1579, 1975, 1760, 1587, 1762, 1792, 1277, 2105, 657, 1807, 1889,
  1646, 692, 1670, 1750, 1747, 1640, 1837, 1278, 1945, 641, 1619, 1431, 1605,
  403, 2000, 2032, 354, 339, 1283, 1902, 1594, 1749, 1703, 1336, 1397, 1874,
  1756, 373, 1612, 2014, 1720, 2033, 1986, 1988, 2116, 1491, 1452, 907, 1677,
  2112, 517, 1388, 2061, 696, 493, 383, 655, 1655, 1721, 1613, 1487, 462, 1984,
  1475, 1480, 1824, 2057, 1622, 1441, 1843, 1296, 2085, 1307, 1718, 451, 1916,
  1915, 1790, 2052,
]; // reduced from 113 to 84 (removed props which did not get more than 10%)

export const sourceTest = ["Google", "google", "webShare", "appShare"];

const manualDefaultPlaces = {
  1760: [
    {
      name: "Kempegowda International Airport",
      geometry: {
        location: {
          lat: 13.1989089,
          lng: 77.70681309999999,
        },
      },
    },
    {
      name: "Padukone - Dravid Centre for Sports Excellence",
      geometry: {
        location: {
          lat: 13.1677366,
          lng: 77.59810379999999,
        },
      },
    },
    {
      name: "Reva University",
      geometry: {
        location: {
          lat: 13.1168745,
          lng: 77.6346118,
        },
      },
    },
    {
      name: "Sir MVIT",
      geometry: {
        location: {
          lat: 13.1510405,
          lng: 77.6100173,
        },
      },
    },
    {
      name: "Nandi Hills",
      geometry: {
        location: {
          lat: 13.370154,
          lng: 77.68345510000002,
        },
      },
    },
    {
      name: "Sri Venkateshwara Engineering College",
      geometry: {
        location: {
          lat: 13.1596355,
          lng: 77.63616739999999,
        },
      },
    },
    {
      name: "Cytecare Cancer hospital",
      geometry: {
        location: {
          lat: 13.1183406,
          lng: 77.60826949999999,
        },
      },
    },
  ],
  2116: [
    {
      name: "Kempegowda International Airport",
      geometry: {
        location: {
          lat: 13.1989089,
          lng: 77.70681309999999,
        },
      },
    },
    {
      name: "Nandi Hills",
      geometry: {
        location: {
          lat: 13.370154,
          lng: 77.68345510000002,
        },
      },
    },
    {
      name: "Devanahalli port",
      geometry: {
        location: {
          lat: 13.2494611,
          lng: 77.7090517,
        },
      },
    },
    {
      name: "Isha Foundation Chikkaballapura",
      geometry: {
        location: {
          lat: 13.4864375,
          lng: 77.7058125,
        },
      },
    },
    {
      name: "Reva University",
      geometry: {
        location: {
          lat: 13.1168745,
          lng: 77.6346118,
        },
      },
    },
    {
      name: "Chanakya University",
      geometry: {
        location: {
          lat: 13.2314729,
          lng: 77.7228427,
        },
      },
    },
    {
      name: "KIADB Aerospace SEZ",
      geometry: {
        location: {
          lat: 13.1741689,
          lng: 77.7313163,
        },
      },
    },
    {
      name: "KIADB Industrial Area Devanahalli",
      geometry: {
        location: {
          lat: 13.2437197,
          lng: 77.7172413,
        },
      },
    },
  ],
  1188: [
    {
      name: "Chinmay Vibhooti Ashram",
      geometry: {
        location: {
          lat: 18.578083,
          lng: 73.540046,
        },
      },
    },
    {
      name: "Hadshi / Pran Pandharpur Temple",
      geometry: {
        location: {
          lat: 18.58252,
          lng: 73.513681,
        },
      },
    },
    {
      name: "Tikona Fort",
      geometry: {
        location: {
          lat: 18.631843,
          lng: 73.51275,
        },
      },
    },
    {
      name: "Pawna Lake",
      geometry: {
        location: {
          lat: 18.666848,
          lng: 73.485783,
        },
      },
    },
    {
      name: "Lohgad Fort",
      geometry: {
        location: {
          lat: 18.710195,
          lng: 73.475862,
        },
      },
    },
    {
      name: "Kamshet Railway Station",
      geometry: {
        location: {
          lat: 18.761137,
          lng: 73.557206,
        },
      },
    },
    {
      name: "Tamini Ghat",
      geometry: {
        location: {
          lat: 18.475911,
          lng: 73.459242,
        },
      },
    },
    {
      name: "Lonavala",
      geometry: {
        location: {
          lat: 18.755724,
          lng: 73.409076,
        },
      },
    },
  ],
  4152: [
    {
      name: "Solitaire Park",
      geometry: {
        location: {
          lat: 26.816208,
          lng: 75.553962,
        },
      },
    },
    {
      name: "Manipal University",
      geometry: {
        location: {
          lat: 26.839906,
          lng: 75.564179,
        },
      },
    },
  ],
};

const excludedProperties = [];

export function hasSpecialCharacters(text) {
  var specialCharacters = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

  for (var i = 0; i < text.length; i++) {
    if (specialCharacters.test(text[i])) {
      return true;
    }
  }
  return false;
}

export const anirudhWhatsappNumber = [];

export const pluralWords = (count, word) => (count > 1 ? `${word}s` : word);

const domains = [
  "dev.hotelzify.com",
  "hotelzify.com",
  "www.hotelzify.com",
  "localhost:3005",
];
const isDev =
  window.location.host.includes("localhost") ||
  window.location.host.includes("dev.hotelzify");
const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
const isPopupBlocked =
  !window.navigator ||
  (window.navigator &&
    window.navigator.userAgent.match(
      /(iPad|iPhone|iPod touch);.*CPU.*OS 7_\d/i
    ))
    ? false
    : true;

const keywordUTM = {
  google_source: "googleSource",
  user_list_id: "userListId",
  utm_campaign: "utmCampaign",
  utm_source: "utmSource",
};

const convertAgeToDOB = (age) => {
  var currentYear = dayjs().year();
  var birthYear = currentYear - age;
  let db = dayjs(new Date(birthYear, dayjs().month(), dayjs().date())).format(
    "YYYY/MM/DD"
  );
  return db;
};

const convertDobToAge = (dob) => {
  let dobYear = dayjs(dob).year();
  let currentYear = dayjs().year();
  return currentYear - dobYear || "";
};

const shouldSendEvent = true; // process.env.REACT_APP_IS_PROD === "true";

const removeSpecialCharacters = (str) => {
  // Use a regular expression to match all special characters and replace them with spaces
  return str?.replace(/[^\w\s]/gi, " ");
};

const couponHotels = [2297];
const couponUserId = [];
const enquiryHotels = [29727, 2373, 29903, 29946, 29947];

const colorHotels = [
  1966, 1984, 1720, 380, 1988, 2303, 2297, 1913, 1360, 671, 1986, 2269, 529, 10,
];

const oyoColorHotels = [1966, 1984, 1988, 2297, 2303];
const mmtColorHotels = [380, 671, 1360, 1720, 1913, 1986, 2269];

export function isDarkColor(r, g, b) {
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance < 0.5;
}

export const learAi = {
  4508: "dcc4add2-0e96-4c60-b0f9-017c09eae062",
  4509: "434ca70e-9cb4-4c8f-add4-94b6dc22393a",
  4510: "176aadae-3d5d-40af-8e6b-4094bd06d15e",
  4606: "9647b15b-bba9-4e94-aca4-a90986515343",
  4607: "14ca28ee-8872-4b72-8fb1-1bbf19fe864e",
  4609: "c57ae5d9-042f-4e94-a331-4e414fc8287a",
  4610: "a5be537e-ec76-4ffd-be8f-746ab2912953",
  4611: "db64a6d9-e071-4e13-a31f-a37609f7f07a",
  4612: "ff8fd961-9f7d-452a-8877-51c5cd711c65",
  4618: "dff3ca2b-2619-4351-97a4-3d2357d1ce45",
  4619: "88b1349a-0ac0-4b86-9c49-12fd1ad1b89d",
  4620: "d960f7bf-1f73-4b45-bdf8-18cdeedf243e",
  4622: "4319816f-63a3-4aed-9f19-5db48f6a2768",
  // 4680: "ee76b2d1-e433-4612-8fd7-8aa4ded7289a",
  5152: "a237e0b0-e9c3-4d12-8f51-367488c95da8",
  5153: "eca9bea6-a5a7-4b6a-bcd0-4413294933b4",
  5154: "f56ecb64-9313-4349-b4f8-6907de443ae2",
  5156: "b87d085a-1336-45c8-a809-c23c07021653",
  5157: "9d39b1cb-04cf-437f-bd8a-5f6becf5c274",
  // 5158: "ffdac326-2122-42f6-a457-bcf2c1919696",
  5159: "a2c9e635-2f94-452d-8176-f1017ac25183",
  5160: "91313050-c718-48c4-ac15-03c1985bfe8a",
  5164: "7f10400c-6e4d-469e-a00c-b53559ec7956",
  5166: "5ee7fc4f-43e0-48e5-9b4f-d6b374359fd9",
  5168: "6390f71b-8f39-462d-af4b-69135f0c1566",
  5170: "312dc227-4c31-4718-a4ff-b77d09b73a89",
  5171: "1b6481d0-c940-4a61-94ab-8d4b610a4d01",
  5179: "c0802fde-b37c-46a4-a77e-2f6ca5f359ee",
  5180: "a7abef51-7953-497d-9769-374713779699",
  5909: "94c93636-fc94-48d1-bd21-eed36ee66f26",
  6056: "d70668c8-7dad-4819-a078-32690c5711e6",
  6057: "f3766ac5-f291-4d10-9ac4-d36a8a3c8b55",
  6196: "7f84dc25-1ee6-4033-bc58-4476260031e5",
  7156: "dff3ca2b-2619-4351-97a4-3d2357d1ce45",
  7157: "dff3ca2b-2619-4351-97a4-3d2357d1ce45",
  14615: "a2a06a88-c0b0-41b0-9e80-f1a47f25c916",
  5151: "2a217e92-dd37-46f4-997d-4e28e3ecaa60",
  5172: "c72d4c72-fb77-45cf-8ef7-1abcdb76881a",
  5173: "586c80c8-3062-42ca-8ae1-050775e4762a",
  5176: "2aaa53a5-2383-4894-99be-f760c68d06b9",
  5177: "9c0afca0-b780-485d-92ba-64fde655c520",
  5169: "2bea914a-ddff-4c1b-bf7e-5e533dac551b",
  5163: "6a97b5aa-12d2-4611-bf6f-c8d93a95b10d",
  5165: "e7f67649-a5d5-46e6-b220-6949ac846355",
  4613: "1b2f1bd4-6b75-41f4-b567-8f1ce4d4d462",
  4615: "7f8bd850-a2c5-4433-bc2f-ef81e1b8b9a5",
  4616: "345156cd-c3b4-43aa-b26c-2070568aaac1",
  4617: "bc74435e-c139-47b0-bf2b-260f71d20450",
  4623: "e8560881-01da-44c4-b241-d4035c2f8ae5",
  7857: "74a6ee60-2a19-4abb-b9ea-7ad76f42c6d4",
  7858: "35ff5782-e290-4d4a-9a0e-04dd5419b2f7",
  7859: "9a779314-f28e-4d92-93eb-66b468fd6f99",
  7860: "ad823ab5-7803-4f0d-9d06-dff385dc3116",
  7861: "816dd9b1-7e93-4804-9b69-9dd281fb21d8",
  7862: "1d3a61e5-4f63-4989-b961-05a46b6d5fda",
  7863: "49cd65b1-de8d-45e2-b19e-56a3c5e147f5",
  7864: "bca3c114-bcf4-4d98-8324-bf0ee2a385d4",
  7865: "da9234b1-a182-4736-a13a-893fbf507615",
  7866: "8ed71297-a24c-4b9d-a6d3-41b8f88cf921",
  7867: "2da45eda-ad6a-42af-a72f-f4a6bf9eaf2e",
  7868: "ca62f852-62c7-485c-8937-0cd63e92cee3",
  7869: "6ac8953e-b429-4c4a-bbfb-12e27033e688",
  7870: "6456fd4b-aacc-4878-a324-a60a6123dc7e",
  7871: "5afeb4de-ce4d-4e95-947d-970b59883179",
  7872: "a53a1e38-2476-44c5-aee5-a918b4fe17fd",
  7873: "f0c04bbd-0ffd-41bd-97f5-8c4f7eb1e05d",
  7875: "f30a57cf-7d64-4d76-bb80-1c154df4723a",
  7876: "d0c8e373-08ac-4da2-8775-af0d8c8de270",
  7877: "21baee22-18df-4a35-8cf7-beeec6b75b56",
  7878: "aa736a9a-c5f4-489f-81e9-e31fe1eb607d",
  7879: "f84d096f-873a-47e6-bd07-e79f90383ac4",
  7880: "fbc3ba61-7bc8-4a9e-a6df-61e3434f22d8",
  7881: "f2affdea-e189-4435-a473-f8f42daafb11",
  7882: "bf409c32-1aa0-4026-acad-f10c468e3465",
  7883: "dca7bec4-ec0c-4ab5-8130-843f0c8a358c",
  7884: "dcd7ef89-4753-4b73-84f6-06a759782836",
  7985: "8a95d9e8-fd88-43b9-bd38-08b8368e6968",
  9056: "9c7fd46e-0efb-4092-bd37-71113d43516e",
  9057: "1a43747c-e598-440e-8376-bebfdc292d8d",
  9081: "2473f76a-1107-4000-ac63-afd100d25a9a",
  9082: "aa15f454-0d28-4953-891d-3c71d5648ae9",
  9083: "ff22d87c-6a19-47fd-9bd6-5abff24ac14b",
  9084: "052cff7a-fa37-4ec3-82a5-a1f81cc28db7",
  9096: "a296c0e0-d1b6-4e30-ba81-c29e7d3c17df",
  9097: "e2db9757-b102-4898-bcb9-546e461db529",
  9098: "e3596dda-5173-418b-a806-89340c3cb835",
  9103: "217b6f25-638f-4dee-9a24-9e8ca022269d",
  9119: "b1f43f25-539c-4eba-888f-9e7a0a6dbcb3",
  9120: "a1bc26ae-4292-4008-8fb2-196b296af7bd",
  9121: "973f55b8-f61b-47d6-9e8a-c30e9bdf7f05",
  9123: "d729379f-1bda-482f-a07e-06812c6bb96f",
  9128: "9a5c9f94-0db6-4b15-8ecc-d07b2098468a",
  9139: "6f18acc6-2dc8-49ee-8105-bb144759f8c9",
  9141: "7ff4df7c-c3f0-4547-98a3-02bdab179352",
  9143: "3c71f93b-5e6c-41e3-9030-357f8a0f0667",
  9144: "d820f515-5fe6-4399-88fe-efcc6db957d1",
  14747: "0b45a771-e1ed-4ebf-bfed-a4722c0b6f28",
  14788: "c3552c91-81a2-4245-b6a5-1039939fc0fc",
  17505: "48dc7758-ac9b-4fbd-8b1a-cdec272aa54d",
  25858: "d1d0721e-647b-464b-be7a-ee35d6b4b925",
  26205: "9bb05ef5-1083-4aef-8dcc-e32401da6583",
  26217: "c9bad499-0263-429f-a4a2-d4166c4b46f8",
  26522: "625f20b9-2071-4bf1-b3f5-1cfa9e7d640b",
};

const timeSlots = [
  "12:00 AM",
  "01:00 AM",
  "02:00 AM",
  "03:00 AM",
  "04:00 AM",
  "05:00 AM",
  "06:00 AM",
  "07:00 AM",
  "08:00 AM",
  "09:00 AM",
  "10:00 AM",
  "11:00 AM",
  "12:00 PM",
  "01:00 PM",
  "02:00 PM",
  "03:00 PM",
  "04:00 PM",
  "05:00 PM",
  "06:00 PM",
  "07:00 PM",
  "08:00 PM",
  "09:00 PM",
  "10:00 PM",
  "11:00 PM",
];

export const EXCLUDE_DISCOUNT_ROOM = [];

function addHoursToTime(hourlyDate, startTime, hoursToAdd, wantDate = false) {
  // Parse the startTime string into a Day.js object

  const dateTimeString = `${dayjs(hourlyDate).format(
    "DD MMM YY"
  )} ${startTime}`;

  // Add the specified number of hours
  const updatedTimeObj = dayjs(dateTimeString).add(hoursToAdd, "hour");

  if (wantDate) {
    let date = dayjs(updatedTimeObj).format("YYYY/MM/DD");
    let time = dayjs(updatedTimeObj).format("hh:mm A");
    return { date, time };
  }

  // Format the updated time as 'hh:mm AM/PM'
  const updatedTimeStr = dayjs(updatedTimeObj).format("hh:mm A");

  return updatedTimeStr;
}

function convert24hrTo12hr(time24hr = "00:00:00") {
  const splitTime = time24hr.split(":");
  let period = "AM";

  let hours12 = parseInt(splitTime[0], 10);

  if (hours12 >= 12) {
    period = "PM";

    if (hours12 >= 24) {
      hours12 = 0;
      period = "AM";
    } else if (hours12 > 12) {
      hours12 -= 12;
    }
  }
  if (hours12 === 0) {
    hours12 = 12;
  }

  return `${hours12.toString().padStart(2, "0")}:${splitTime[1]} ${period}`;
}

function isStartTimeBeforeEndTime(startTime, endTime) {
  // Parse the time strings using dayjs
  const start = dayjs(`08-10-2023 ${startTime}`);
  const end = dayjs(`08-10-2023 ${endTime}`);

  // Check if the start time is before the end time
  return !start.isAfter(end);
}

function convert12hrTo24hr(time12hr) {
  const [time, period] = time12hr.split(" ");
  const [hours, minutes] = time.split(":");

  let hours24 = parseInt(hours, 10);

  if (period === "PM" && hours24 !== 12) {
    hours24 += 12;
  } else if (period === "AM" && hours24 === 12) {
    hours24 = 0;
  }

  return `${hours24.toString().padStart(2, "0")}:${minutes}`;
}

export function generateRandomBinary() {
  return Math.round(Math.random());
}

function removeDuplicateObjectsById(arr) {
  const uniqueObjects = {};
  const result = [];

  for (const obj of arr) {
    const id = obj.id;

    // If the object with this id hasn't been added yet, add it to the result array
    if (!uniqueObjects[id]) {
      result.push(obj);
      uniqueObjects[id] = true;
    }
  }

  return result;
}

export const distanceCalculation = (lat1, lon1, lat2, lon2, isMI = false) => {
  const R = 6371; // Radius of the Earth in kilometers
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lon2 - lon1) * (Math.PI / 180);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * (Math.PI / 180)) *
      Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  let distance = R * c; // Distance in kilometers

  if (isMI) {
    distance *= 0.621371;
  }

  return distance?.toFixed(2);
};

export function sortRoomsByPriceAndAvailability(rooms) {
  let availRooms = rooms?.filter((rm) => rm?.availableRooms > 0);

  let nonAvailRooms = rooms?.filter((rm) => rm?.availableRooms === 0);

  function getMinPriceBeforeTax(pricingObj) {
    if (!pricingObj) return;
    return Math.min(...pricingObj.priceForPax.map((p) => p.priceBeforeTax));
  }

  availRooms.forEach((obj) => {
    obj.pricing.sort(
      (a, b) => getMinPriceBeforeTax(a) - getMinPriceBeforeTax(b)
    );
  });

  availRooms.sort(
    (a, b) =>
      getMinPriceBeforeTax(a.pricing[0]) - getMinPriceBeforeTax(b.pricing[0])
  );

  return [...availRooms, ...nonAvailRooms];
}

export const getApplicableTax = ({ taxes = [], amount, level }) => {
  return taxes.filter((tax) => {
    const isNotLevel = level && tax.level !== level;
    const notPriceFrom = tax.priceFrom && amount < tax.priceFrom;
    const notPriceTo = tax.priceTo && amount > tax.priceTo;
    return !isNotLevel && !notPriceFrom && !notPriceTo;
  });
};

export const getCalculatedTax = ({
  taxes = [],
  rooms,
  isInclusive = true,
  noOfNights = 1,
}) => {
  const [roomTaxes, bookingTaxes] = taxes.reduce(
    ([roomTaxes, bookingTaxes], tax) => {
      (tax.level === "room" ? roomTaxes : bookingTaxes).push(tax);
      tax.totalTax = 0;
      return [roomTaxes, bookingTaxes];
    },
    [[], []]
  );
  const appliedTaxes = [];
  const calculateTax = ({ roomId = null, taxes, amount, level }) => {
    let amountAfterTax = amount;
    let roomTax = 0;
    taxes
      .sort((a, b) => a.index - b.index)
      .forEach((tax) => {
        const usingAmount = tax.useIndex ? amountAfterTax : amount;
        let taxAmount = tax.tax;
        if (tax.taxType === "percentage") {
          if (isInclusive) {
            taxAmount = usingAmount - usingAmount / (1 + tax.tax / 100);
          } else {
            taxAmount = (usingAmount * tax.tax) / 100;
          }
        }
        const amountWithoutTax =
          (usingAmount - (isInclusive ? taxAmount : 0)) / noOfNights;
        const isNotLevel = level && tax.level !== level;
        const notPriceFrom = tax.priceFrom && amountWithoutTax < tax.priceFrom;
        const notPriceTo = tax.priceTo && amountWithoutTax > tax.priceTo;
        if (isNotLevel || notPriceFrom || notPriceTo) {
          return;
        }
        if (tax.taxType === "fixed" && tax.level === "room") {
          taxAmount = taxAmount * (noOfNights || 1);
        }
        roomTax += taxAmount;
        amountAfterTax += isInclusive ? -taxAmount : taxAmount;
        appliedTaxes.push({
          roomId,
          tax,
          taxAmount,
          level,
        });
        tax.totalTax = (tax.totalTax ?? 0) + taxAmount;
      });
    return roomTax;
  };
  let totalAmount = 0;
  let totalRoomTax = 0;
  rooms.forEach((room) => {
    const roomTax = calculateTax({
      roomId: room.id,
      taxes: roomTaxes,
      amount: room.amount,
      level: "room",
    });
    room.roomTax = roomTax;
    totalAmount += room.amount;
    totalRoomTax += roomTax;
  });
  const totalBookingTax = calculateTax({
    taxes: bookingTaxes,
    amount: totalAmount,
    level: "booking",
  });
  return {
    totalTax: totalRoomTax + totalBookingTax,
    taxes: taxes.sort((a, b) => a.index - b.index),
    rooms,
    totalRoomTax: isInclusive ? -totalRoomTax : totalRoomTax,
    totalBookingTax,
    appliedTaxes,
  };
};

export const removeDuplicates = (arr, key) => {
  const seen = new Set();
  return arr.filter((item) => {
    const id = item[key];
    if (seen.has(id)) {
      return false;
    } else {
      seen.add(id);
      return true;
    }
  });
};

const loadPaytringSDK = () => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://cdn.paytring.com/js/checkout/iframe.v1.2.0.js"; // Replace with actual SDK URL

    script.onload = () => {
      // SDK loaded successfully
      resolve();
    };

    script.onerror = (err) => {
      // Handle error in loading the SDK
      reject(new Error("Failed to load Paytring SDK", err));
    };

    document.body.appendChild(script);
  });
};

export const openPaytring = async (
  orderResp,
  hotelId,
  paymentProvider,
  callback = () => {}
) => {
  const { order, payment } = orderResp;
  await loadPaytringSDK();

  // Define a function to be executed if the transaction fails
  async function fail_handle(order_id) {}

  // Define a function to be executed if the transaction is successful
  async function success_handle(order_id) {
    const obj = {
      gateway: "razorpay",
      paymentId: payment.id,
      hotelId: hotelId,
      vendor: paymentProvider?.vendor,
      superVendor: paymentProvider?.superVendor,
    };
    callback(orderResp, obj);
  }

  // Define a function to log events
  async function event_happen(resp) {
    console.log("Event Name: " + resp.event_name);
    console.log("Event Value: " + resp.event_value);
  }

  async function on_close(order_id) {
    let mixObj = {
      bookingObj: storageService.get("bookingObj") || {},
      bookingId: storageService.get("bookingId") || 0,
      reason: "modal_closed_paytring",
    };
    fireGtmEvent("payment_closed", { data: mixObj });
  }

  // Define options for the Paytring Iframe
  var options = {
    order_id: orderResp?.order?.order_id, // Replace with the order id you received when creating the order
    success: success_handle,
    failed: fail_handle,
    events: event_happen, // This function executes on various events, such as when the user selects a payment option, changes the payment option, or clicks the payment proceed button
    onClose: on_close,
  };

  // Create an instance of the Paytring class with the specified options
  /* global Paytring */
  const paytring = new Paytring(options);

  // Open the Paytring Iframe
  paytring.open();
};

const loadPCIBookingSDK = () => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://cdn.pcibooking.net/sdk/v1/pcibooking.js"; // Replace with actual PCI Booking SDK URL
    
    script.onload = () => {
      // SDK loaded successfully
      resolve();
    };
    
    script.onerror = (err) => {
      // Handle error in loading the SDK
      reject(new Error("Failed to load PCI Booking SDK", err));
    };
    
    document.body.appendChild(script);
  });
};

export const openPCIBooking = async (
  orderResp,
  hotelId,
  paymentProvider,
  callback = () => {}
) => {
  const { order, payment } = orderResp;
  await loadPCIBookingSDK();
  
  // Define a function to be executed if the transaction fails
  async function fail_handle(response) {
    console.log("PCI Booking payment failed", response);
    toastr.error("Payment failed. Please try again.");
  }
  
  // Define a function to be executed if the transaction is successful
  async function success_handle(response) {
    const obj = {
      gateway: "pcibooking",
      paymentId: payment.id,
      hotelId: hotelId,
      vendor: paymentProvider?.vendor,
      superVendor: paymentProvider?.superVendor,
      pcibookingPaymentId: response?.paymentId,
      pcibookingTransactionId: response?.transactionId,
    };
    callback(orderResp, obj);
  }
  
  async function on_close() {
    let mixObj = {
      bookingObj: storageService.get("bookingObj") || {},
      bookingId: storageService.get("bookingId") || 0,
      reason: "modal_closed_pcibooking",
    };
    fireGtmEvent("payment_closed", { data: mixObj });
  }
  
  // Define options for the PCI Booking modal
  var options = {
    orderId: orderResp?.order?.order_id,
    amount: order.amount,
    currency: order.currency,
    hotelId: hotelId,
    vendorKey: paymentProvider?.vendorKey,
    onSuccess: success_handle,
    onFailure: fail_handle,
    onClose: on_close,
  };
  
  // Create an instance of the PCI Booking payment modal
  /* global PCIBooking */
  if (window.PCIBooking) {
    const pciBooking = new window.PCIBooking(options);
    pciBooking.open();
  } else {
    console.error("PCI Booking SDK not loaded");
    toastr.error("Payment system is not available. Please try again.");
  }
};

let lastUsedApiIndex = -1;

const getLocationDetails = async () => {
  const apiEndpoints = [
    "https://ipapi.co/json/",
    "http://ip-api.com/json/",
    "https://ipwho.is/",
  ];

  let randomIndex;
  do {
    randomIndex = Math.floor(Math.random() * apiEndpoints.length);
  } while (randomIndex === lastUsedApiIndex);

  lastUsedApiIndex = randomIndex;
  const selectedApi = apiEndpoints[randomIndex];

  const locationResp = await axios.get(selectedApi);
  let locationDetails = {};

  if (locationResp.status === 200) {
    locationDetails = {
      ip: locationResp.data.ip || locationResp.data.query,
      city: locationResp.data.city,
      region: locationResp.data.region || locationResp.data.regionName,
      country_name: locationResp.data.country_name || locationResp.data.country,
      country: locationResp.data.country_code || locationResp.data.countryCode,
      country_calling_code:
        locationResp.data.country_calling_code ||
        locationResp.data.dialcode ||
        locationResp.calling_code,
      ...locationResp.data,
      selectedApi,
    };
  }

  return locationDetails;
};

function isValidTimeZone(tz) {
  try {
    Intl.DateTimeFormat(undefined, { timeZone: tz });
    return true;
  } catch (e) {
    return false;
  }
}

export {
  IMAGE_QUALITY,
  isStartTimeBeforeEndTime,
  convertDobToAge,
  excludedProperties,
  convert12hrTo24hr,
  domains,
  removeSpecialCharacters,
  isIOS,
  isSafari,
  isPopupBlocked,
  instaProps,
  instaPropsArr,
  isDev,
  keywordUTM,
  deviceType,
  shouldSendEvent,
  convertAgeToDOB,
  scrollProperties,
  timeSlots,
  addHoursToTime,
  convert24hrTo12hr,
  manualDefaultPlaces,
  couponHotels,
  removeDuplicateObjectsById,
  tawkProps,
  colorHotels,
  oyoColorHotels,
  mmtColorHotels,
  couponUserId,
  getLocationDetails,
  isValidTimeZone,
  enquiryHotels,
};
